import { type ReactNode } from 'react'
import { RewardCard, RewardChip, FlashIcon, Tooltip } from '@repo/ui'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'

type BoosterItemProps = Readonly<{
  reward: string
  isMobile?: boolean
  tooltip?: ReactNode
  onClick?: () => void
}>

export function BoosterItem({ reward, isMobile = false, tooltip, onClick }: BoosterItemProps) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  
  const sharedProps = {
    accentColor: 'blue' as const,
    icon: <FlashIcon className="w-[14px] h-[14px] drop-shadow-[0_0_2px_rgba(0,0,0,0.25)]" />,
    onClick,
    reward
  }

  const content = isMobile 
    ? <RewardChip {...sharedProps} />
    : <RewardCard {...sharedProps} label={t('booster')} />

  return tooltip ? (
    <Tooltip position="top" trigger={content}>{tooltip}</Tooltip>
  ) : content
}